export const getActivitiesByRef = (state) => {
  return state.activities.byRef;
};
